// extracted by mini-css-extract-plugin
export var chevronIcon = "_41-2";
export var teamName = "_41-1";
export var teamSwitcherButton = "_41-0";